import script from "./CreateAnnotationFeature.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAnnotationFeature.vue?vue&type=script&setup=true&lang=js"

import "./CreateAnnotationFeature.vue?vue&type=style&index=0&id=d5698922&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5698922"]])

export default __exports__